import React, { useMemo } from 'react';
import { reflowFinals, formatMMSS } from './reflow';

// formatMMSS переехал в reflow.js; реэкспорт сохраняет внешние импорты.
export { formatMMSS };

// LiveTranscript — живой поток live-распознавания: финалы пересобраны в абзацы
// (reflowFinals: склейка по пунктуации, разрыв по паузам; моно-таймкод из start
// первого высказывания абзаца, БЕЗ «Имя:» — диаризации в live-режиме нет),
// плюс «хвост» partial — курсивом, серым, с розовой подсветкой-градиентом
// и мигающим кареткой (класс live-partial, анимация — src/index.css).
// showTimecodes: во время записи метки всегда видны; после стопа — WYSIWYG
// с чекбоксом «С тайм-кодами» (что на экране, то и в копии/файле).
export default function LiveTranscript({ finals = [], partial = '', showTimecodes = true }) {
  const paras = useMemo(() => reflowFinals(finals), [finals]);
  const isEmpty = paras.length === 0 && !partial;
  return (
    <div className="text-[15px] leading-[1.7] text-paper-ink max-w-[72ch]">
      {isEmpty && (
        <div className="text-[14px] text-paper-ink-3">
          Говорите — текст появится здесь по мере распознавания…
        </div>
      )}
      {paras.map((p, i) => (
        <p key={i} className="mb-3">
          {showTimecodes && (
            <span className="mr-3 font-mono text-[13px] text-paper-hint">[{formatMMSS(p.startSec)}]</span>
          )}
          <span>{p.text}</span>
        </p>
      ))}
      {partial && (
        <p className="mb-3">
          <span className="live-partial italic text-paper-ink-3">
            {partial}
          </span>
        </p>
      )}
    </div>
  );
}
